import service from "fetchers";

const userAuthenticationApi = {
  login: (body) => service.post("/iam/v1/auth/login", body),
  getMyProfile: () => service.get("/iam/v1/auth/me")
};

export default userAuthenticationApi;
